import { CompanyContactId, SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountCompaniesQueryKey, accountQueryKey } from "../account.keys";

export const useAdminDeleteCompanyContact = (accountId: SuretyAccountId) => {
	const queryClient = useQueryClient();
	const { _delete } = useRequest();

	const mutation = useMutation({
		mutationFn: async (companyContactId: CompanyContactId) => {
			await _delete(
				`/v2/admin/surety/accounts/${accountId}/companies/${companyContactId}`,
				undefined,
				"none",
			);
		},
		onSuccess: async () => {
			await Promise.all([
				queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) }),
				queryClient.invalidateQueries({ queryKey: accountCompaniesQueryKey(accountId) }),
			]);
		},
	});

	return {
		deleteCompanyContact: mutation.mutate,
		deleteCompanyContactError: mutation.error,
		deleteCompanyContactIsLoading: mutation.isPending,
		deleteCompanyContactSuccess: mutation.isSuccess,
	};
};
